module.exports = __webpack_public_path__ + "img/file_view_info.542ba2fe.png";